import React from "react";
import Header from "./components/Header.js";
import Home from "./pages/Home.js";
import Footer from "./components/Footer.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./pages/Contact.js";

import VoIPBusinessSolutions from "./pages/VoipBusinessSolutions.js";
import WebMobileSolutions from "./pages/webMobileSolutions.js";
// import ConsultancyAndDiscovery from "./pages/ConsultancyAndDiscovery.js";
import QAServices from "./pages/QAServices.js";
import DevopsServices from "./pages/DevopsServices.js";
//Hire Developers
import AndroidDevelopers from "./pages/HireDevelopers/AndroidDevelopers.js";
import AsteriskDeveloper from "./pages/HireDevelopers/AsteriskDeveloper.js";
import AWSMigrationEngineers from "./pages/HireDevelopers/AWSMigrationEngineers.js";
import DevOpsEngineers from "./pages/HireDevelopers/DevOpsEngineer.js";
import FreeSwitchDevelopers from "./pages/HireDevelopers/FreeSwitchDevelopers.js";
import LaravelDevelopers from "./pages/HireDevelopers/LaravelDevelopers.js";
import MernDevelopers from "./pages/HireDevelopers/MernDevelopers.js";
import NodeDeveloper from "./pages/HireDevelopers/NodeDeveloper.js";
import PythonDeveloper from "./pages/HireDevelopers/PythonDeveloper.js";
import ReactDeveloper from "./pages/HireDevelopers/ReactDeveloper.js";
import ReactNativeDevelopers from "./pages/HireDevelopers/ReactNativeDevelopers.js";
import VoIPDevelopers from "./pages/HireDevelopers/VoIPDevelopers.js";
import WebRtcDeveloper from "./pages/HireDevelopers/WebRtcDeveloper.js";
import IosDevelopers from "./pages/HireDevelopers/IosDevelopers.js";
import PhpDevelopers from "./pages/HireDevelopers/PhpDevelopers.js";
//VoIP Solutions
import AudioVideoConfSolution from "./pages/voipSolutions/AudioVideoConfSolution.js";
import ContactCenterSolution from "./pages/voipSolutions/ContactCenterSolution.js";
import DynamicIvrSolution from "./pages/voipSolutions/DynamicIvrSolution.js";
import FoipTelepresence from "./pages/voipSolutions/FoipTelepresence.js";
import EnterpriseVoipSolution from "./pages/voipSolutions/EnterpriseVoipSolution.js";
import HostedPbxSolutions from "./pages/voipSolutions/HostedPbxSolutions.js";
import SmsBroadcastingSystem from "./pages/voipSolutions/SmsBroadcastingSystem.js";
import CommunicationApi from "./pages/voipSolutions/CommunicationApi.js";
import SmallBusinessVoipSolution from "./pages/voipSolutions/SmallBusinessVoipSolution.js";

//Offerings
import FreeSwitch from "./pages/offerings/voip/FreeSwitch.js";
import Asterisk from "./pages/offerings/voip/Asterisk.js";
import OpenSips from "./pages/offerings/voip/OpenSips.js";
import WebRTc from "./pages/offerings/voip/WebRTc.js";
import ClickToCall from "./pages/offerings/voip/ClickToCall.js";
import CicdPipeline from "./pages/offerings/devops/CiCdPipelines.js";
import StreamingPlatfom from "./pages/offerings/devops/StreamingPlatform.js";
import CloudServices from "./pages/offerings/devops/CloudServices.js";
import VoiceAssistant from "./pages/offerings/VoiceAssistant.js";
import MobileAppDev from "./pages/offerings/webMobile/MobileAppDev.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import Magento from "./pages/SoftwareDevelopment/Magento.js";
import WordPress from "./pages/SoftwareDevelopment/WordPress.js";
import OpenCart from "./pages/SoftwareDevelopment/OpenCart.js";
import Terms from "./pages/Terms.js";
import FrontendDev from "./pages/SoftwareDevelopment/FrontendDev.js";
import FullStackDev from "./pages/SoftwareDevelopment/FullStackDev.js";

import Products from "./pages/Products.js";
import OurPartners from "./pages/OurPartners.js";
import { HelmetProvider } from "react-helmet-async";
import AboutUs from "./pages/about/AboutUs.jsx";
import AwsSolutions from "./pages/offerings/devops/AwsSolutions.jsx";
import AzureSolutions from "./pages/offerings/devops/AzureSolutions.jsx";
import CloudDeployments from "./pages/offerings/devops/CloudDeployments.jsx";
import DockerContainers from "./pages/offerings/devops/DockerContainers.jsx";
import KubernetesClusters from "./pages/offerings/devops/KubernetesClusters.jsx";
import HelmCharts from "./pages/offerings/devops/HelmCharts.jsx";
import ServiceMesh from "./pages/offerings/devops/ServiceMesh.jsx";
import TerraformAutomation from "./pages/offerings/devops/TerraformAutomation.jsx";
import AnsibleAutomation from "./pages/offerings/devops/AnsibleAutomation.jsx";
import JenkinsAutomation from "./pages/offerings/devops/JenkinsAutomation.jsx";
import GithubActions from "./pages/offerings/devops/GithubActions.jsx";
import CICDPipelines from "./pages/offerings/devops/CICDPipelines.jsx";
import Monitoring from "./pages/offerings/devops/Monitoring.jsx";
import LoggingStack from "./pages/offerings/devops/LoggingStack.jsx";
// import ArgoCD from "./pages/offerings/devops/ArgoCD.jsx";
import SecurityScanning from "./pages/offerings/devops/SecurityScanning.jsx";
import AIAutomationTemplate from "./pages/offerings/aiautomation/AIAutomationTemplate.jsx";
import AICallingAgent from "./pages/offerings/aiautomation/AICallingAgent.jsx";
import AIChatbot from "./pages/offerings/aiautomation/AIChatbot.jsx";
import AIRPAAssistant from "./pages/offerings/aiautomation/AIRPAAssistant.jsx";
import AISalesAssistant from "./pages/offerings/aiautomation/AISalesAssistant.jsx";
import AISupportBot from "./pages/offerings/aiautomation/AISupportBot.jsx";
import AutonomousAIAgent from "./pages/offerings/aiautomation/AutonomousAIAgent.jsx";
import CustomAIAgent from "./pages/offerings/aiautomation/CustomAIAgent.jsx";
import DataIntelligenceAgent from "./pages/offerings/aiautomation/DataIntelligenceAgent.jsx";
import VoiceBotAssistant from "./pages/offerings/aiautomation/VoiceBotAssistant.jsx";
import HireEngineers from "./pages/HireDevelopers/HireEngineer.js"
import NotFound from "./pages/NotFound.js";
import Migration from "./pages/Migration.js";
import AwsToHetzner from "./pages/aws-to-hetzner.js";
import AzureToHetzner from "./pages/Azure-to-hetzner.js";
import GcpToHetzner from "./pages/Gcp-to-hetzner.js";
import DigitaloceanHetzner from "./pages/Digitalocean-to-hetzner.js";
import OvhToHetzner from "./pages/Ovh-to-hetzner.js";
import ScalewayToHetzner from "./pages/Scaleway-to-hetzner.js";
import LinodeToHetzner from "./pages/Linode-to-hetzner.js";
import Portal from "./pages/portal.js";
import Hetzner from "./pages/Hetzner.js";

function App() {
  return (
    <div className="gradient-background">
      <HelmetProvider>
        <Router>
          <Header />
          <div style={{ marginTop: "80px" }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contactus" element={<Contact />} />
              <Route
                path="/voip-business-solutions"
                element={<VoIPBusinessSolutions />}
              />
              <Route
                path="/web-mobile-solutions"
                element={<WebMobileSolutions />}
              />
              
              <Route path="/qa-services" element={<QAServices />} />
              <Route path="/devops-services" element={<DevopsServices />} />
              //Hire Developers
              <Route
                path="/hire-android-developers"
                element={<AndroidDevelopers />}
              />
              <Route
                path="/hire-asterisk-developers"
                element={<AsteriskDeveloper />}
              />
              <Route
                path="/hire-aws-migration-engineers"
                element={<AWSMigrationEngineers />}
              />
              <Route
                path="/hire-devops-engineers"
                element={<DevOpsEngineers />}
              />
              <Route
                path="/hire-freeswitch-developers"
                element={<FreeSwitchDevelopers />}
              />
              <Route
                path="/hire-laravel-developers"
                element={<LaravelDevelopers />}
              />
              <Route
                path="/hire-mern-developers"
                element={<MernDevelopers />}
              />
              <Route path="/hire-node-developers" element={<NodeDeveloper />} />
              <Route
                path="/hire-python-developers"
                element={<PythonDeveloper />}
              />
              <Route
                path="/hire-react-developers"
                element={<ReactDeveloper />}
              />
              <Route
                path="/hire-reactnative-developers"
                element={<ReactNativeDevelopers />}
              />
              <Route
                path="/hire-voip-developers"
                element={<VoIPDevelopers />}
              />
              <Route
                path="/hire-webrtc-developers"
                element={<WebRtcDeveloper />}
              />
              <Route path="/hire-ios-developers" element={<IosDevelopers />} />
              <Route
                path="/hire-react-developers"
                element={<ReactDeveloper />}
              />
              <Route path="/hire-php-developers" element={<PhpDevelopers />} />
              //VoIP Solutions
              <Route
                path="/audio-video-conference"
                element={<AudioVideoConfSolution />}
              />
              <Route
                path="/contact-center-solution"
                element={<ContactCenterSolution />}
              />
              <Route
                path="/dynamic-ivr-solution"
                element={<DynamicIvrSolution />}
              />
              <Route
                path="/enterprise-voip-solution"
                element={<EnterpriseVoipSolution />}
              />
              <Route path="/foip-telepresence" element={<FoipTelepresence />} />
              <Route
                path="/hosted-pbx-solution"
                element={<HostedPbxSolutions />}
              />
              <Route
                path="/sms-broadcasting-system"
                element={<SmsBroadcastingSystem />}
              />
              <Route path="/communication-api" element={<CommunicationApi />} />
              <Route
                path="/small-business-voip-solution"
                element={<SmallBusinessVoipSolution />}
              />

              <Route path="/hire-azure-devops" element={<HireEngineers />} />

              <Route path="about-us" element={<AboutUs />} />
              <Route path="/devops-aws" element={<AwsSolutions />} />
              <Route path="/devops-azure" element={<AzureSolutions />} />
              <Route path="/devops-kubernetes" element={<KubernetesClusters />} />
              <Route path="/devops-helm" element={<HelmCharts />} />
              <Route path="/devops-cloud-native" element={<CloudDeployments />} />
              <Route path="/devops-docker" element={<DockerContainers />} />
              <Route path="/devops-service-mesh" element={<ServiceMesh />} />
              <Route path="/devops-terraform" element={<TerraformAutomation />} />
              <Route path="/devops-ansible" element={<AnsibleAutomation />} />
              <Route path="/devops-jenkins" element={<JenkinsAutomation />} />
              <Route path="/devops-github-actions" element={<GithubActions />} />
              <Route path="/devops-ci-cd" element={<CICDPipelines />} />
              <Route path="/devops-prometheus" element={<Monitoring />} />
              <Route path="/devops-elk" element={<LoggingStack />} />
              {/* <Route path="/devops-argocd" element={<ArgoCD />} /> */}
              <Route path="/devops-security" element={<SecurityScanning />} />
 
             //AI Automation
             <Route path="/ai-calling-agent" element={<AICallingAgent />} />
             <Route path="/ai-chatbot" element={<AIChatbot />} />
             <Route path="/ai-rpa" element={<AIRPAAssistant/>} />
             <Route path="/ai-sales-assistant" element={<AISalesAssistant />} />
             <Route path="/ai-support-bot" element={<AISupportBot />} />
             <Route path="/ai-agent" element={<AutonomousAIAgent />} />
             <Route path="/ai-custom-agent" element={<CustomAIAgent/>} />
             <Route path="/ai-data-agent" element={<DataIntelligenceAgent/>} />
             <Route path="/ai-voicebot" element={<VoiceBotAssistant />} />


              //Offerings -- VoIP
              <Route path="/asterisk" element={<Asterisk />} />
              <Route path="/freeswitch" element={<FreeSwitch />} />
              <Route path="/click-to-call" element={<ClickToCall />} />
              <Route path="/opensips" element={<OpenSips />} />
              <Route path="/webrtc" element={<WebRTc />} />
              <Route path="/cicd-pipelines" element={<CicdPipeline />} />
              <Route path="streaming-platform" element={<StreamingPlatfom />} />
              <Route path="cloud-services" element={<CloudServices />} />
              <Route path="voice-assistant" element={<VoiceAssistant />} />
              <Route path="mobile-app-dev" element={<MobileAppDev />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms" element={<Terms />} />
              //Software Development
              <Route path="/magento" element={<Magento />} />
              <Route path="/wordpress" element={<WordPress />} />
              <Route path="/opencart" element={<OpenCart />} />
              <Route path="/frontend-dev" element={<FrontendDev />} />
              <Route path="/fullstack-dev" element={<FullStackDev />} />
              <Route path="/products" element={<Products />} />
              <Route path="/our-partners" element={<OurPartners />} />
              <Route path="/hetzner-cloud-migration" element={<Migration />} />
              <Route path="/aws-to-hetzner-migration" element={<AwsToHetzner />} />
              <Route path="/azure-to-hetzner-migration" element={<AzureToHetzner />} />
              <Route path="/google-cloud-to-hetzner" element={<GcpToHetzner />} />
              <Route path="/digitalocean-to-hetzner-cloud-migration" element={<DigitaloceanHetzner />} />
              <Route path="/ovh-to-hetzner-cloud-migration" element={<OvhToHetzner />} />
              <Route path="/scaleway-to-hetzner-cloud-migration" element={<ScalewayToHetzner />} />
              <Route path="/linode-to-hetzner-cloud-migration" element={<LinodeToHetzner />} />
              <Route path="/hetzner-cloud-client-portal" element={<Portal />} />
              <Route path="/hetzner-cloud-services" element={<Hetzner />} />
              <Route path="*" element={<NotFound/>} />
            </Routes>
          </div>
          <Footer />
        </Router>
      </HelmetProvider>
    </div>
  );
}

export default App;
